








import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";

export default defineComponent({
  name: "FileImageView",
  components: { BaseIcon },
  props: {
    name: { type: String },
    icon: { type: String, required: true },
    small: { type: Boolean },
  },
});
